// extracted by mini-css-extract-plugin
module.exports = {"section":"DownloadSection-module--section--3c2tX","content":"DownloadSection-module--content--3mwSi","subcontent":"DownloadSection-module--subcontent--1hgvR"};